import { Button } from "@workspace/web-ui/components/button"
// import { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs"
 import EmptyState from "./empty-state"

interface SuggestiveAnswer {
  id: string;
  text: string;
  type: string;
}

interface OnboardingMessage {
  id: string;
  type: 'bot' | 'user';
  content: string;
  suggestiveAnswers?: SuggestiveAnswer[];
}

interface OnboardingChatHistory {
  session_id: string;
  user_id: string;
  message: OnboardingMessage[];
  created_at: string;
}

// interface DiseaseInfo {
//   condition: string;
//   justification: string;
//   confidence_level?: string;
// }

// interface ParsedContent {
//   follow_up_question?: string;
//   options?: string[];
//   probable_diseases?: DiseaseInfo[];
//   improbable_diseases?: DiseaseInfo[];
//   needs_one_more_round?: boolean;
// }

interface ChatMessage {
  type: 'human' | 'ai';
  data: {
    content: string;
    parsed_content?: any;
  };
  created_at: string;
}

interface AlfieChatHistory {
  session_id: string;
  message: ChatMessage;
  created_at: string;
}

interface ChatHistoryProps {
  chatHistory: {
    onboard_chat_history: OnboardingChatHistory[];
    alfie_chat_history: AlfieChatHistory[];
  },
  encounter?:any,
  resumeChatWithAlfie: () => void
}

export default function EncountersDetailsChatHistory({chatHistory,encounter,resumeChatWithAlfie}: ChatHistoryProps){
  // const [activeTab, setActiveTab] = useState<string>('question');

  if (!chatHistory || !chatHistory.onboard_chat_history || !chatHistory.alfie_chat_history) {
    return <div className="text-center text-red-500">No chat history available.</div>;
  }

  // Get the latest onboarding chat history
  const latestOnboardingChat = chatHistory.onboard_chat_history[chatHistory.onboard_chat_history.length - 1];

  // const renderParsedContent = (parsedContent: ParsedContent) => {
  //   // Check if the content is in the structured format
  //   const isStructuredContent = parsedContent.follow_up_question || 
  //     (parsedContent.options && parsedContent.options.length > 0) ||
  //     (parsedContent.probable_diseases && parsedContent.probable_diseases.length > 0) ||
  //     (parsedContent.improbable_diseases && parsedContent.improbable_diseases.length > 0);

  //   if (!isStructuredContent) {
  //     // If not structured, just return the content as normal text
  //     return (
  //       <div className="text-[15px] text-[#1A202C]">
  //         {parsedContent.follow_up_question || ''}
  //       </div>
  //     );
  //   }

  //   // const tabs = [
  //   //   { id: 'question', label: 'Question', visible: !!parsedContent.follow_up_question },
  //   //   { id: 'options', label: 'Options', visible: !!parsedContent.options?.length },
  //   //   { id: 'probable', label: 'Probable Conditions', visible: !!parsedContent.probable_diseases?.length },
  //   //   { id: 'improbable', label: 'Ruled Out', visible: !!parsedContent.improbable_diseases?.length },
  //   // ].filter(tab => tab.visible);

  //   return (
  //     <div className="flex flex-col gap-4 mt-2">
  //       {/* {tabs.length > 0 && (
  //         <div className="flex border-b border-gray-200">
  //           {tabs.map((tab) => (
  //             <button
  //               key={tab.id}
  //               onClick={() => setActiveTab(tab.id)}
  //               className={`px-4 py-2 text-sm font-medium ${
  //                 activeTab === tab.id
  //                   ? 'text-[#4272DD] border-b-2 border-[#4272DD]'
  //                   : 'text-[#464B55] hover:text-[#4272DD]'
  //               }`}
  //             >
  //               {tab.label}
  //             </button>
  //           ))}
  //         </div>
  //       )} */}

  //       <div className="mt-2">
  //         {activeTab === 'question' && parsedContent.follow_up_question && (
  //           <div className="bg-[#F8F9FA] p-4 rounded-lg">
  //             <h4 className="text-[14px] font-medium text-[#1A202C] mb-2">Follow-up Question</h4>
  //             <p className="text-[15px] text-[#464B55]">{parsedContent.follow_up_question}</p>
  //           </div>
  //         )}

  //         {/* {activeTab === 'options' && parsedContent.options && parsedContent.options.length > 0 && (
  //           <div className="bg-[#F8F9FA] p-4 rounded-lg">
  //             <h4 className="text-[14px] font-medium text-[#1A202C] mb-2">Response Options</h4>
  //             <div className="flex flex-col gap-2">
  //               {parsedContent.options.map((option, index) => (
  //                 <button
  //                   key={index}
  //                   className="text-left px-4 py-2 bg-white rounded-lg border border-gray-200 hover:bg-gray-50"
  //                 >
  //                   {option}
  //                 </button>
  //               ))}
  //             </div>
  //           </div>
  //         )} */}

  //         {/* {activeTab === 'probable' && parsedContent.probable_diseases && parsedContent.probable_diseases.length > 0 && (
  //           <div className="bg-[#F8F9FA] p-4 rounded-lg">
  //             <h4 className="text-[14px] font-medium text-[#1A202C] mb-2">Probable Conditions</h4>
  //             <div className="flex flex-col gap-2">
  //               {parsedContent.probable_diseases.map((disease, index) => (
  //                 <div key={index} className="bg-white p-3 rounded-lg border border-gray-200">
  //                   <div className="flex justify-between items-start">
  //                     <span className="text-[14px] font-medium text-[#1A202C]">{disease.condition}</span>
  //                     {disease.confidence_level && (
  //                       <span className="text-[12px] text-[#4272DD] bg-[#EBF2FF] px-2 py-1 rounded">
  //                         {disease.confidence_level} Confidence
  //                       </span>
  //                     )}
  //                   </div>
  //                   <p className="text-[13px] text-[#464B55] mt-1">{disease.justification}</p>
  //                 </div>
  //               ))}
  //             </div>
  //           </div>
  //         )}

  //         {activeTab === 'improbable' && parsedContent.improbable_diseases && parsedContent.improbable_diseases.length > 0 && (
  //           <div className="bg-[#F8F9FA] p-4 rounded-lg">
  //             <h4 className="text-[14px] font-medium text-[#1A202C] mb-2">Ruled Out Conditions</h4>
  //             <div className="flex flex-col gap-2">
  //               {parsedContent.improbable_diseases.map((disease, index) => (
  //                 <div key={index} className="bg-white p-3 rounded-lg border border-gray-200">
  //                   <span className="text-[14px] font-medium text-[#1A202C]">{disease.condition}</span>
  //                   <p className="text-[13px] text-[#464B55] mt-1">{disease.justification}</p>
  //                 </div>
  //               ))}
  //             </div>
  //           </div>
  //         )} */}
  //       </div>
  //     </div>
  //   );
  // };
   return (
    <div>
      <div className="flex flex-col gap-[16px] px-[16px]">
        <div className="flex flex-row gap-[8px] justify-between items-center w-full">
          <div style={{border: "1px solid",borderImageSource: "linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(102, 102, 102, 0.5) 100%)"}} className="w-full bg-[#66666680] h-[1px]"></div>
          <div className="flex flex-col w-[40vw] text-center gap-[8px]">
            <span className="text-[#464B55] text-[14px] font-normal leading-[140%] tracking-[-1%]">Start of chat session</span>
          </div>
          <div style={{border: "1px solid",borderImageSource: "linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(102, 102, 102, 0.5) 100%)"}} className="w-full bg-[#66666680] h-[1px]"></div>
        </div>

        {/* Onboarding Chat History */}
        {latestOnboardingChat?.message.map((msg) => (
          <div 
            key={msg.id} 
            className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'} w-full`}
          >
            <div 
              className={`
                ${msg.type === 'user' 
                  ? 'bg-[#F1F4F9] border-[#4272DD] border-[1px] rounded-[16px] rounded-br-[0px]' 
                  : 'bg-[#F1F4F9] rounded-[16px] rounded-bl-[0px]'
                }
                w-fit max-w-[70%] p-[16px]
              `}
              style={msg.type === 'bot' ? {
                boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.03), 0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 2px 1px 0px rgba(0, 0, 0, 0.02), 0px 4px 2px 0px rgba(0, 0, 0, 0), 0px 7px 2px 0px rgba(0, 0, 0, 0)'
              } : {}}
            >
              <div className="flex flex-col gap-[4px]">
                <span className={`text-[15px] leading-[137%] tracking-[-1%] ${
                  msg.type === 'user' 
                    ? 'text-[#4272DD] font-medium' 
                    : 'text-[#1A202C] font-normal'
                }`}>
                  {msg.content}
                </span>
                {/* {msg.suggestiveAnswers && msg.suggestiveAnswers.length > 0 && (
                  <div className="flex flex-col gap-2 mt-2">
                    {msg.suggestiveAnswers.map((answer) => (
                      <button
                        key={answer.id}
                        className="text-left px-4 py-2 bg-white rounded-lg border border-gray-200 hover:bg-gray-50"
                      >
                        {answer.text}
                      </button>
                    ))}
                  </div>
                )} */}
              </div>
            </div>
          </div>
        ))}

        {/* Alfie Chat History */}
        {chatHistory.alfie_chat_history.map((chat, index) => (
          <div 
            key={index} 
            className={`flex ${chat.message.type === 'human' ? 'justify-end' : 'justify-start'} w-full`}
          >
            <div 
              className={`
                ${chat.message.type === 'human' 
                  ? 'bg-[#F1F4F9] border-[#4272DD] border-[1px] rounded-[16px] rounded-br-[0px]' 
                  : 'bg-[#F1F4F9] rounded-[16px] rounded-bl-[0px]'
                } ${Array.isArray(chat.message.data.parsed_content) ? 'w-full !bg-white border border-[#0404041A]' : 'w-fit max-w-[70%]'}  p-[16px]
              `}
              style={chat.message.type === 'ai' ? {
                boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.03), 0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 2px 1px 0px rgba(0, 0, 0, 0.02), 0px 4px 2px 0px rgba(0, 0, 0, 0), 0px 7px 2px 0px rgba(0, 0, 0, 0)'
              } : {}}
            >
              <div className="flex flex-col gap-[4px]">
                {typeof chat.message.data.parsed_content === 'string' ? (
                  <span className={`text-[15px] leading-[137%] tracking-[-1%] ${
                    chat.message.type === 'human' 
                      ? 'text-[#4272DD] font-medium' 
                      : 'text-[#1A202C] font-normal'
                  }`}>
                    {chat.message.data.parsed_content}
                  </span>
                ) : Array.isArray(chat.message.data.parsed_content) ? (
                  <div className="w-full flex flex-col gap-8 ">
                    {chat.message.data.parsed_content.map((diagnosis, index) => (
                      <DiagnosisScreen key={index} {...diagnosis} />
                    ))}
                  </div>
                ) : (
                  <div className="w-full rounded-[12px]">
                    {chat.message.data.parsed_content?.follow_up_question}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}

        <div className="flex flex-col gap-[8px]">

          {encounter?.session?.onboard_session ==='ended' && encounter?.session?.alfie_session === 'ended' ? ( 
            <>
              <div className="bg-[#FFF5E6] flex flex-col gap-[8px] justify-center items-center p-[12px] rounded-[28px]">
                <span className="text-[#1A202C] text-[20px] font-medium leading-[150%] tracking-[-1%]">Payment</span>
                <div className="flex flex-row justify-between w-full items-center bg-[#FFFFFF] rounded-[16px] p-[12px] gap-[8px]">
                  <span className="text-[#464B55] text-[16px] font-normal leading-[140%] tracking-[-1%]">Medical Consultation</span>
                  <span className="text-[#1A202C] text-[16px] font-medium leading-[137%] tracking-[-1%]">$50.00</span>
                </div>
              </div>
              <Button  className="border-[#DCDCDE]   h-auto w-full text-[#FFFFFF] !py-[12px] !px-[16px] rounded-[10px]">
                Proceed to consultation payment
              </Button>
            </>            
          ):(             
            <Button onClick={() => resumeChatWithAlfie()} variant="outline"  className="border-[#DCDCDE]   h-auto w-full text-[#464B55] !py-[12px] !px-[16px] rounded-[10px]">
              Resume chat with Alfie
            </Button>
          )}
        </div>

        <div className="flex flex-row gap-[8px] justify-between items-center w-full">
        <div style={{border: "1px solid",borderImageSource: "linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(102, 102, 102, 0.5) 100%)"}} className="w-full bg-[#66666680] h-[1px]"></div>
        <div className="flex flex-col w-[40vw] text-center gap-[8px]">
            <span className="text-[#464B55] text-[14px] font-normal leading-[140%] tracking-[-1%]">Chat in progress</span>
          </div>
          <div style={{border: "1px solid",borderImageSource: "linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(102, 102, 102, 0.5) 100%)"}} className="w-full bg-[#66666680] h-[1px]"></div>
        </div>
      </div>
    </div>
  );
}
const DiagnosisScreen = (diagnosis:any) => {

  return (
    <div className="flex flex-col gap-[16px]">            
    <div className="flex flex-col gap-[8px] px-0">
    <h1 className="text-[#1A202C] text-[15px] font-medium leading-[130%] tracking-[-2%]">Diagnosis</h1>
    <h1 className="text-[#1A202C] text-[14px] font-medium leading-[130%] tracking-[-2%]">{diagnosis.disease_name}</h1>

    <div className="flex flex-col gap-[8px]">
        <span className="text-[#1A202C] text-[15px] leading-[137%] font-medium tracking-[-1%]">Overview</span>
        <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">{diagnosis.overview}</p>
    </div>
    <div className="flex flex-wrap gap-[12px]">
      {
        diagnosis.image_urls?.map((src:any, index:number) => (
            <img key={index} className="w-[136px] rounded-[8px] h-[136px]" src={src} alt="" />
        ))
      }
    </div>

</div>
 <div className="flex flex-col gap-[8px] px-0">
        <span className="text-[#1A202C] text-[16px] leading-[137%] font-medium tracking-[-1%]">Symptoms</span>
        <div className="">
        <ul className="list-disc list-inside grid grid-cols-2 justify-between gap-[8px] text-[#464B55] text-[12px] leading-[140%] font-normal tracking-[-1%]">
           {
            diagnosis.symptoms?.map((symptom:any, index:number) => (
                <li key={index}>{symptom}</li>
            ))
           }
        </ul>
        </div>
  </div>
  <div className="flex flex-col gap-[8px] px-0">
        <div className="flex flex-col gap-[8px] border border-[#0404041A] bg-[#F1F4F9] rounded-[12px]">              
             <Tabs defaultValue="Causes" className="w-full">
                <TabsList className="flex w-full justify-around h-auto overflow-x-scroll rounded-none my-0 gap-2 border-b bg-transparent px-0 py-0">
                    <TabsTrigger 
                        value="Causes" 
                        className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-[8px] rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                    >
                        Causes
                    </TabsTrigger>
                    <TabsTrigger 
                        value="Diagnosis" 
                        className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-[8px] rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                    >
Diagnosis                                </TabsTrigger>
                    <TabsTrigger 
                        value="Treatment" 
                        className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-[8px] rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                    >
                        Treatment
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="Causes" className=" p-[10px]">
                                      <ul className="list-disc list-inside text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
           {
            diagnosis?.causes?.map((cause:any, index:number) => (
                <li key={index}>{cause}</li>
            ))
           }
        </ul>

                 </TabsContent>
                <TabsContent value="Diagnosis" className="p-[8px]">
                                      <ul className="list-disc list-inside text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
           {
            diagnosis?.diagnosis?.map((cause:any, index:number) => (
                <li key={index}>{cause}</li>
            ))
           }
        </ul>
                </TabsContent>
                <TabsContent value="Treatment" className="p-[8px]">

                                      <ul className="list-disc list-inside text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                                {diagnosis?.treatment_page?.medications?.length > 0 ? (
            <ul className="list-disc pl-5 space-y-1">
              {diagnosis?.treatment_page?.medications?.map((treatment:any, index:number) => (
                <li key={index} className="text-sm">
                  <strong>{treatment.medication} ({treatment.category})</strong>: {treatment.instructions.join(', ')}
                </li>
              ))}
            </ul>
          ) : (
                            <EmptyState title="No treatment information available." message="" type="prescription" />
          )}
        </ul>
                </TabsContent>
            </Tabs>
        </div> 
  </div>
  <div className="flex hidden flex-col gap-[8px]">
        <h1 className="text-[#1A202C] text-[14px] font-medium leading-[130%] tracking-[-2%]">Doctors note</h1>
        <div>  
           <EmptyState title="No diagnosis yet" message="A note will appear here after you've had a consultation with a doctor." type="doctors_note" />
      
            <ul className="list-disc hidden pl-4  text-[#464B55] text-[16px] leading-[140%] font-normal tracking-[-1%]">
           {
            Array.from({ length: 2 }).map((_, index) => (
                <li key={index} className="mb-4">
                  <div className="flex flex-col gap-[8px] ">         
                    <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Patient presented with classic symptoms of URTI. Prescribed antibiotic treatment. Advised rest and increased fluid intake. </p>
                    <span className="text-[#464B55] text-[12px] leading-[140%] underline font-normal tracking-[-1%]">24 April, 2025 - Follow up appointment</span>
                  </div>
                 </li>
            ))
           }
        </ul>
      </div>
  </div>
  </div>
  )};